import { createEvent, createStore } from 'effector';
export const toggleLanguage = createEvent();
const initLanguage = localStorage.getItem('i18nextLng') || 'ru';
export const languageStore = createStore(initLanguage).on(toggleLanguage, (_, newLang) => newLang);
languageStore.watch((newLang) => {
    localStorage.setItem('i18nextLang', newLang);
});
